import React, { useEffect, useState } from 'react';
import { Backdrop, Box, Button, IconButton, Typography, Modal } from '@mui/material';
import orgLogo from '../../assets/LandingPage/ocean-engine.svg';
import denyIcon from '../../assets/LandingPage/Org/denyIcon.svg';
import acceptIcon from '../../assets/LandingPage/Org/acceptIcon.svg';
import { styled } from '@mui/system';
import { organizationAPI } from '../../api/requests/organization/organizationAPI';
import './Invite.css';
import CloseIcon from '@mui/icons-material/Close';

const ModalHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '24px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(2),
}));
const ModalFooter = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  paddingTop: theme.spacing(2),
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
}));

const Invite = ({ inviteId, setSelectedOrgName }) => {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(true);
  const [inviteInfo, setInviteInfo] = useState();
  useEffect(() => {
    organizationAPI
      .getInvite(inviteId)
      .then((data) => {
        setInviteInfo(data.inviteData);
        setLoading(false);
      })
      .catch(() => {
        handleClose();
      });
  }, []);
  const handleClearStorage = () => {
    const inviteId = localStorage.getItem('inviteId')
    if (inviteId) {
      localStorage.removeItem('inviteId')
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseAndClearStorage = () => {
    handleClose()
    handleClearStorage()
  }

  const acceptInvite = () => {
    organizationAPI
      .inviteAction(inviteId, 'ACCEPT')
      .then(() => {
        handleClearStorage()
        window.location.replace(`/org/${inviteInfo?.organizationdata?.name}/dashboard`);
        localStorage.setItem('orgName', inviteInfo?.organizationdata?.name);
      })
      .catch(() => handleClose());
  };
  const rejectInvite = () => {
    organizationAPI
      .inviteAction(inviteId, 'REJECT')
      .then(() => {
        handleClearStorage()
        window.location.replace('/organization')
      })
      .catch(() => handleClose());
  };

  return (
    <div>
      <Modal
        open={open && !loading}
        onClose={handleCloseAndClearStorage}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <div className="inviteActionModal " style={{ backgroundColor: "var(--color-bg-paper)" }}>
          <ModalHeader>
            <Box>
              <Typography variant="h6" id="modal-title" sx={{ mb: '4px' }}>
                You have received an Invite:
              </Typography>
              <Typography
                variant="subtitle2"
                id="modal-description"
                sx={{ lineHeight: 1.6, color: "var(--color-text-secondary)" }}
              >
                View and respond to organizations invitations and thoughtfully express your decision
                to accept or decline the invitations.
              </Typography>
            </Box>
            <IconButton onClick={handleCloseAndClearStorage} sx={{ position: 'absolute', top: '8px', right: '8px', zIndex: 4 }}>
              <CloseIcon />
            </IconButton>
          </ModalHeader>
          <div className="inviteActionCon" style={{ backgroundColor: "var(--color-bg-paper)" }}>
            <div className="inviteActionOrg">
              <img
                width={'60px'}
                height={'60px'}
                style={{ objectFit: 'cover' }}
                srcSet={[inviteInfo?.organizationdata?.orglink, orgLogo]}
                alt=""
              />
              <div className="inviteActionOrgName">
                <Typography variant="h5" id="modal-title" sx={{ pb: '4px' }}>
                  {inviteInfo?.organizationdata?.name}
                </Typography>
                <Typography variant="body2" id="modal-description" sx={{ color: 'var(--color-text-secondary)' }}>
                  {inviteInfo?.organizationdata?.domain}
                </Typography>
              </div>
            </div>
          </div>
          <ModalFooter>
            <Button
              variant="outlined"
              color="error"
              sx={{
                height: '36px',
                padding: '6px 16px',
                width: 'fit-content',
                gap: '8px',
                justifyContent: 'space-between',
              }}
              onClick={rejectInvite}
              endIcon={<img width="24px" height="24px" src={denyIcon} alt="" />}
            >
              Deny
            </Button>
            <Button
              variant="contained"
              sx={{
                minWidth: '120px',
                height: '36px',
                padding: '6px 16px',
                width: 'fit-content',
                gap: '8px',
              }}
              onClick={acceptInvite}
              endIcon={<img width="20px" height="20px" src={acceptIcon} alt="" />}
            >
              Accept
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};

export default Invite;
